import * as semver from 'semver'

// Parent APKs up to 2.2.0 must be updated from the store before anything else.
export const isOldParentApk = () => typeof window.os !== 'undefined' && semver.lte(window.apkVersion, '2.2.0')

// An app build that opens v3.rutasegura.co: older parent app builds (current ones open app.rutasegura.co, the
// driver app opens driver.rutasegura.co). A few staff still work from one, so the router sends only parent
// accounts to the update page.
export const isAppOnV3Host = () => typeof window.os !== 'undefined' && location.hostname === 'v3.rutasegura.co'
